module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_8003.e941a0fd.png";